import React, {useEffect, useState} from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import LeftSlider from "./common/left-slider/left-slider";
import Notifications from "./pages/notifications/notificationsTab";
import Setting from "./pages/setting/setting";
import Account from "./pages/account/account";
import PrivateRoute from "./PrivateRouter";
import Fleet from "./pages/fleet-management/fleet-management";
import FleetDetails from "./pages/fleet-management/fleets-details";
import ViewFleet from "./pages/fleet-management/view-fleet";
import AuthLayout from "./common/auth-layout";
import { Suspense } from "react";
import { Spin } from "antd";
import OrdersDetails from "./pages/orders/order-details";
import DocumentStatus from "./pages/orders/document-status-update";
import EarningsTnxOderDetails from "./pages/earnings/components/tnx-order-details";
import EarningsTnxPaymentDetails from "./pages/earnings/components/tnx-payment-details";
import EarningInvoice from "./pages/earnings/earnings-invoice";
import InvoiceUploadModel from "./pages/earnings/add-new-invoice-upload-model";
import HelpAndSupport from "./pages/help-and-support/help-and-support";
import SupplierDetails from "./pages/fleet-management/supplier-details";
import Fulfilment from "./pages/fulfilment/fulfilment";
import GuestLayout from "./common/guest-layout";
import * as localStorageService from "./service/localStorageService";
import { useStore } from "./store/store";
import { PublicLayout } from "./common/public-layout";

const Login = React.lazy(() => import("./pages/login/login/login"));
const Privacy = React.lazy(() => import("./pages/login/login/privacy"));
const Signup = React.lazy(() => import("./pages/login/sign-up/sign-up"));
const ForgotPassword = React.lazy(() => import("./pages/login/forgot-password/forgot-password"));
const Home = React.lazy(() => import("./pages/home/home"));
const Loads = React.lazy(() => import("./pages/loads/loads"));
const MyBids = React.lazy(() => import("./pages/my-bids/my-bids"));
const MyBidsDetails = React.lazy(() => import("./pages/my-bids/bids-details-page"));
const Orders = React.lazy(() => import("./pages/orders/orders"));
const Earnings = React.lazy(() => import("./pages/earnings/earnings"));

const Router=() =>{
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { guestUser } = useStore();

  useEffect(() => {
    const user = localStorageService.getValue("user"); 
    setIsAuthenticated(!!user);  
  }, []);
  

  useEffect(()=>{
  },[])
  
  const routes= [
    {
      path: "/",
      component: <Navigate to="/home" />,
    },
    {
      path: "/home",
      component: <Home/>,
    },
    {
      path: "/loads",
      component: <Loads/>,
    },
    {
      path: "/loads/:inquiryId",
      component: <Loads/>,
    },
    {
      path: "/my-bids/submissions",
      component: <MyBids/>,
    },
    {
      path: "/my-bids/awarded",
      component: <MyBids/>,
    },
    {
      path: "/my-bids/submissions/:inquiryId",
      component: <MyBidsDetails />,
    },
    {
      path: "/my-bids/awarded/:inquiryId",
      component: <MyBidsDetails />,
    },
    {
      path: "/orders",
      component: <Orders/>,
    },
    {
      path: "/orders/:orderId",
      component: <OrdersDetails/>,
    },
    {
      path: "/orders/:orderId/:tripId/:name",
      component: <DocumentStatus/>,
    },
    {
      path: "/view-fleet",
      component: <ViewFleet/>,
    },
    {
      path: "/supplier-detail/:supplierId",
      component: <SupplierDetails/>,
    },
    {
      path: "/fleet-management",
      component: <Fleet />,
    },
    {
      path: "/supplier-fleet/:supplierId/:supplierName",
      component: <Fleet />,
    },
    {
      path: "/fleet-management/:driverORTruckId/:supplierId?/:name",
      component: <FleetDetails />,
    },
    {
      path: "/earnings",
      component: <Earnings/>,
    },
    {
      path: "/earnings/orderDetails/:id",
      component: <EarningsTnxOderDetails/>,
    },
    {
      path: "/earnings/paymentDetails/:id",
      component: <EarningsTnxPaymentDetails/>,
    },
    {
      path:"/earnings/invoice-upload",
      component: <EarningInvoice/>
    },
    {
      // path:"/earnings/add-new-invoice/:id",
      path:"/earnings/add-new-invoice",
      component: <InvoiceUploadModel/>
    },
    {
      path: "/notifications",
      component: <Notifications/>,
    },
    {
      path: "/setting",
      component: <Setting/>,
    },
    {
      path: "/account",
      component: <Account/>,
    },
    {
      path: "/helpAndSupport",
      component: <HelpAndSupport/>,
    },
    {
      path: "/fulfilments",
      component: <Fulfilment/>
    }
  ];

  const renderRoutes = (route) => {
    if (route.children) {
      return (
        <Route
          key={route.path}
          path={route.path}
          element={route.component}
          index
        >
          {route.children.map((childRoute) => renderRoutes(childRoute))}
        </Route>
      );
    } else {
      return (
        <Route
          key={route.path}
          path={route.path}
          element={route.component}
          exact={route.exact}
          index
        />
      );
    }
  };
  return(
    <Suspense fallback={<Spin tip="Loading..." />}>
      <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<Signup />} />
        <Route path="/forgot-password/:id" element={<ForgotPassword />} />
        <Route path="/forgot-password/:id/:countryCode/:mobileNumber" element={<ForgotPassword />} />
        <Route path="/forgot-password/:id/:email" element={<ForgotPassword />} />
        </Route>
        {guestUser ? (
          <Route element={<GuestLayout />}>
          {routes.map((route, index) => renderRoutes(route) )}
          </Route>
        ) 
        : 
        // (
        //   isAuthenticated && (
            <Route element={<PrivateRoute><AuthLayout /></PrivateRoute>}>
            {routes.map((route, index) => renderRoutes(route) )}
            </Route>
          // ) 
        // )
        }
      </Routes>
    </Suspense>
  )
}
export default Router;
